export default __webpack_public_path__ + "static/media/fundcard-bg.5ca36d78.svg";